module.exports = __webpack_public_path__ + "media/img/logos/bosch-af934d428ad393ba1671e70bf3fc8c88.svg";